import React from 'react';
import {convertISODateTimeToBRLocale} from "../../../common/Util";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper/Paper";


const ReactHighcharts = require('react-highcharts');
//var Moment = require('moment-timezone');
//require('moment/locale/pt-br');

class AutoclaveCicloDistinctPresets extends React.Component {
    constructor(props) {
        super(props);
        this.state={};
    };


    componentDidMount(){
        //   this.props.getItensManual();

    }

    componentDidUpdate(oldProps, oldState){

      //  console.log('didUpdate')
    }




    render() {
        const { ciclo } = this.props;
        const { isOpen } = this.state;

        console.log("indicador ciclo presets", ciclo);

        if (!ciclo || ciclo.length < 1) { return null; }






        return (
            <React.Fragment>
                {ciclo.map( (p,ix) => {
                    return(
                        <Grid container key={ix} style={{ alignItems:'stretch', padding: '2px', justifyContent: 'space-between' }}>
                            <Grid item  xs={2} sm={2} md={2} lg={2} xl={2} style={{ alignItems:'stretch', padding: '2px' }}>
                                <Paper>
                                    <Grid container direction="column" style={{ alignItems:'center'}}>
                                        <Grid item>
                                            <Typography   variant="caption">RECEITA</Typography>
                                        </Grid>
                                        <Grid item>
                                            <Typography variant="h4">{p.receitaNumero > 0 ? p.receitaNumero : '--'}</Typography>
                                        </Grid>
                                        <Grid item style={{ alignContent:'right' }}>
                                            <Typography variant="subtitle1">painel</Typography>
                                        </Grid>
                                    </Grid>

                                </Paper>
                            </Grid>

                            <Grid item  xs={2} sm={2} md={2} lg={2} xl={2} style={{ alignItems:'stretch', padding: '2px' }}>
                                <Paper>
                                    <Grid container direction="column" style={{ alignItems:'center'}}>
                                        <Grid item>
                                            <Typography   variant="caption">AUTOCLAVE</Typography>
                                        </Grid>
                                        <Grid item>
                                            <Typography variant="h4">{p.presetPressaoAutoclave}</Typography>
                                        </Grid>
                                        <Grid item style={{ alignContent:'right' }}>
                                            <Typography variant="subtitle1">psi</Typography>
                                        </Grid>
                                    </Grid>

                                </Paper>
                            </Grid>

                            <Grid item  xs={2} sm={2} md={2} lg={2} xl={2} style={{ alignItems:'stretch', padding: '2px' }}>
                                <Paper>
                                    <Grid container direction="column" style={{ alignItems:'center'}}>
                                        <Grid item>
                                            <Typography   variant="caption">ENVELOPE</Typography>
                                        </Grid>
                                        <Grid item>
                                            <Typography variant="h4">{p.presetPressaoEnvelope}</Typography>
                                        </Grid>
                                        <Grid item style={{ alignContent:'right' }}>
                                            <Typography variant="subtitle1">psi</Typography>
                                        </Grid>
                                    </Grid>

                                </Paper>
                            </Grid>

                            <Grid item  xs={2} sm={2} md={2} lg={2} xl={2} style={{ alignItems:'stretch', padding: '2px' }}>
                                <Paper>
                                    <Grid container direction="column" style={{ alignItems:'center'}}>
                                        <Grid item>
                                            <Typography   variant="caption">SACO DE AR</Typography>
                                        </Grid>
                                        <Grid item>
                                            <Typography variant="h4">{p.presetPressaoSacoDeAr}</Typography>
                                        </Grid>
                                        <Grid item style={{ alignContent:'right' }}>
                                            <Typography variant="subtitle1">psi</Typography>
                                        </Grid>
                                    </Grid>

                                </Paper>
                            </Grid>
                            <Grid item  xs={2} sm={2} md={2} lg={2} xl={2} style={{ alignItems:'stretch', padding: '2px' }}>
                                <Paper>
                                    <Grid container direction="column" style={{ alignItems:'center'}}>
                                        <Grid item>
                                            <Typography   variant="caption">Vulcanização</Typography>
                                        </Grid>
                                        <Grid item>
                                            <Typography variant="h4">{p.presetTempoVulcanizacao > 0 ? p.presetTempoVulcanizacao : '--'}</Typography>
                                        </Grid>
                                        <Grid item style={{ alignContent:'right' }}>
                                            <Typography variant="subtitle1">minutos</Typography>
                                        </Grid>
                                    </Grid>

                                </Paper>
                            </Grid>

                        </Grid>
                    )})}
            </React.Fragment>
        )
    }
}



export default AutoclaveCicloDistinctPresets

